import React from "react";

const uz = {
	main: {
		siteTitle: "Reactfolio — Qodirxon Nodirxonov",
	},

	nav: {
		home: "Boş sahifa",
		about: "Men haqimda",
		projects: "Loyihalar",
		skills: "Skillar",
		articles: "Maqolalar",
		contact: "Aloqa",
		resume: "Rezyume",
		resumeTitle: "Rezyumeni yuklab oliş",
	},

	lang: {
		uz: "ÓZB",
		en: "EN",
		ru: "RU",
	},

	footer: {
		credits: "© Nodirkhanov Qodirkhan",
	},

	titles: {
		about: "Men haqimda",
		projects: "Loyihalar",
		skills: "Skillar",
		articles: "Maqolalar",
		contact: "Aloqa",
	},

	homepage: {
		title: "Men — Nodirkhanov Qodirkhan.",
		description:
			"Men React.js bóyiça tajribaga ega backend dasturçisiman. Turli framework va texnologiyalar yordamida masştablanuvçi, xavfsiz va işonçli veb-ilovalarni yaratişda tajribam bor. Murakkab masalalarni yeçişni va yangi kónikmalarni órganişni yaxşi kóraman. Eng yaxşi amaliyotlar va sanoat standartlariga mos yuqori sifatli kod yozişga intilaman. Doimiy ravişda yangi qiyinçiliklar va ósiş imkoniyatlarini qidiraman.",
	},

	about: {
		title: "Men haqimda",
		description: `Salom, men Qodirxon Nodirxonov — 15-fevralda tuǵilgan, 18 yoşli ǵayratli veb-dasturçiman. Zamonaviy, responsiv va dinamik veb-ilovalarni eng sónggi texnologiyalar bilan yaratişga ixtisoslaşganman.

React.js, JavaScript, Node.js, HTML va CSS bóyiça kuçli kónikmalarim bilan ǵoyalarni toza kod va silliq foydalanuvçi tajribasi orqali hayotga tatbiq etişni yaxşi kóraman. Doimo órganiş, ósiş va odamlarning hayotini osonlaştiruvçi raqamli yeçimlar yaratişga intilaman.

Kod yozmasam, yangi texnologik trendlarni órganaman, oçiq manbali loyihalarga hissa qóşaman yoki jamiyat bilan bilim ulaşaman. Hamkorlik va uzluksiz órganiş kuçiga işonaman — bu soha tez ózgaradi.
Keyingi loyihangiz uçun fidoyi va iştiyoqmand dasturçi qidirsangiz, bemalol boǵlaning.
Keling, birga ajoyib narsa yaratamiz!`,
	},

	articlesIntro: {
		title: "Hayotimdagi yangiliklar haqida.",
		description:
			"Bu yerda hayotimdagi voqealarni maqola şaklida yoritib boraman.",
	},

	projectsPage: {
		title: "Olamlarga iz qoldirişga urinib yaratgan işlarim.",
		subtitle: `Yillar davomida turli loyihalar ustida işladim va erişgan natijalarimdan faxrlanaman. Kópçilik loyihalar oçiq manbali va boşqalar ularni órganişi, hissa qóşişi mumkin. Qaysidir loyiha qiziq bólsa, kodni kórib çiqing va takliflaringizni bildiring. Hamkorlik — órganiş va ósişning yaxşi yóli, men yangi ǵoya va fikr-mulohazalarga doim oçiqman.`,
	},

	contact: {
		pageTitle: "Ǵoyangiz bormi? Keling, uni birga hayotga tatbiq etamiz.",
		lead:
			"Loyiha, hamkorlik taklifi yoki şunçaki savol — qaysi biri bólmasin, yozing. Har bir xabarni ózim óqiyman va albatta javob beraman.",
		available: "Yangi loyihalarga oçiqman",
		response: "Odatda 24 soat içida javob beraman",
		cards: {
			email: "Rasmiy takliflar va hamkorlik uçun",
			telegram: "Eng tezkor yól — şu yerda tez javob beraman",
			instagram: "Kundalik hayotim va yangiliklarim",
			github: "Kodlarim va oçiq loyihalarim",
		},
		write: "Yoziş",
		closing:
			"Eng yaxşi loyihalar oddiy “salom”dan boşlanadi. Birinçi qadamni siz qóying!",
	},

	socials: {
		telegram: "Telegram’da kuzating",
		github: "GitHub’da kuzating",
		instagram: "Instagram’da kuzating",
	},

	works: {
		cardTitle: "Ta’lim",
		entries: [
			{
				title: "Namangan 22-maktab",
				subtitle: "11 yil",
				duration: "2015 - 2026",
			},
			{
				title: "Namangandagi Start 21",
				subtitle: "1 yil | ingliz tili",
				duration: "2024 - 2025",
			},
			{
				title: "IT ni órganiş",
				subtitle: "Algoritm",
				duration: "2023 - 2025",
			},
			{
				title: "PDP University",
				subtitle: "Talaba",
				duration: "2026 - hozirgaça",
			},
		],
	},

	articleLink: "Maqolani óqiş",

	projects: [
		{
			title: "Navbat Tizimi — Şerdor Medical",
			description:
				"Klinika uçun tóliq elektron navbat va boşqaruv tizimi: kiosk, registratura, kassa, laboratoriya, şifokor va rahbar ilovalari. Zal televizorida ózbekça ovozli e’lonlar, bemorlarga SMS va Telegram xabarnomalar, laboratoriya natijalarini QR orqali tekşiriş. Internet uzilganda ham işlaydi va ma’lumotlar serverga avtomatik sinxronlanadi. Node.js, React, MongoDB, Electron va Android’da yozilgan.",
			linkText: "Loyihani kóriş",
		},
		{
			title: "Loyiha 1",
			description:
				"Telegram Stars savdosi uçun yozilgan bot. Foydalanuvçi bot içida Stars xarid qilişi, buyurtma holatini kuzatişi va tezkor javob olişi mumkin. Bot havolasi: @uzbstarsbuybot",
			linkText: "Loyihani kóriş",
		},
		{
			title: "Loyiha 2",
			description:
				"Tólaqonli Telegram savdo boti: premium obuna, Stars, gift va NFT’larni sotib oliş imkoniyati mavjud. Bot React va PHP texnologiyalarida yozilgan. Bot havolasi: @milliydokonbot",
			linkText: "Loyihani kóriş",
		},
	],

	articles: [
		{
			date: "25.10.2026",
			title: "Navbat tizimi: klinika uçun elektron navbatni qanday qurdim.",
			description:
				"Qoǵoz navbat va şovqinli zaldan to kiosk, televizordagi ovozli e’lon va rahbar ilovasigaça — Navbat tizimi qanday paydo bóldi…",
			keywords: ["Navbat", "elektron navbat", "klinika", "Qodirkhan"],
			style: "",
			body: (
				<React.Fragment>
					<div className="article-content">
						<div className="paragraph">
							Hammasi oddiy kuzatuvdan boşlandi: klinikada bemorlar
							navbatni qoǵoz yoki oǵzaki kelişuv bilan kutardi, kim
							kimdan keyin kirişi tez-tez bahsga aylanardi, registratura
							esa bir vaqtning ózida ham róyxatga oliş, ham navbatni
							boşqariş bilan ovora edi. Şunda men klinikaning butun iş
							jarayonini bitta tizimga birlaştirişga qaror qildim —
							şunday qilib Navbat tizimi paydo bóldi.
							<br />
							<br />
							Tizim bir neçta ilovadan iborat. Bemor kioskdan çipta oladi
							yoki registraturada róyxatdan ótadi. Kassa tólovni qabul
							qiladi, laboratoriya tahlil natijalarini kiritadi, şifokor
							esa óz kabinetidan navbatdagi bemorni çaqiradi. Zaldagi
							televizorda navbat raqamlari kórinadi va çaqiruv ózbek
							tilida ovozli e’lon qilinadi — bemor ekranga tikilib ótirişi
							şart emas.
							<br />
							<br />
							Bemorlar uçun ham qulayliklar qóşdim: SMS va Telegram
							orqali xabarnomalar, laboratoriya natijasini esa çekdagi
							QR-kod orqali tekşiriş mumkin. Klinika rahbari uçun alohida
							Android ilova yozdim — unda kunlik tuşum, bemorlar soni,
							xonalar bandligi va hisobotlarni istalgan joydan kóriş
							mumkin.
							<br />
							<br />
							Texnik tomondan tizim Node.js va MongoDB asosidagi serverda,
							React’da yozilgan veb-interfeyslarda, Electron’dagi desktop
							ilovalarda va Android’da işlaydi. Bu loyiha menga bitta ilova
							emas, balki real foydalanuvçilar har kuni tayanadigan butun
							ekotizimni loyihalaşni órgatdi.
						</div>
					</div>
				</React.Fragment>
			),
		},
		{
			date: "18.10.2026",
			title: "Internet uzilsa ham işlaydigan tizim: Navbat’dan olgan saboqlarim.",
			description:
				"Klinikada internet bir soatga uzilsa ham iş tóxtamasligi kerak. Offline rejim, avtomatik yangilaniş va zaxira nusxalar haqida…",
			keywords: ["Navbat", "offline", "zaxira", "Node.js", "Qodirkhan"],
			style: "",
			body: (
				<React.Fragment>
					<div className="article-content">
						<div className="paragraph">
							Navbat tizimini işga tuşirgandan keyin eng muhim saboq şu
							bóldi: klinikada internet uzilişi — bu “agar” emas, “qaçon”
							degan savol. Bemorlar esa kutib turmaydi. Şuning uçun tizim
							avvalo klinika içidagi mahalliy serverda işlaydi:
							registratura, kassa, laboratoriya va zal televizori
							internetsiz ham bir-biri bilan bemalol boǵlanadi.
							<br />
							<br />
							Internet qaytganda ma’lumotlar bulutdagi serverga avtomatik
							sinxronlanadi. Bu yerda eng qiyin qism — heç bir yozuv
							yóqolmasligi va ikki marta yozilmasligi. Har bir çek va
							tólov uçun noyob identifikator, qayta urinişlar navbati va
							server tomonida takroriy yozuvlardan himoya qóşdim. Pul
							bilan işlaydigan tizimda bitta yóqolgan çek ham katta
							muammo.
							<br />
							<br />
							Yangi versiyalarni har bir kompyuterga qólda órnatib çiqiş
							ham imkonsiz edi, şuning uçun avtomatik yangilaniş
							mexanizmini yozdim: ilovalar yangi versiyani ózi yuklab oladi
							va órnatadi, ma’lumotlar esa alohida, xavfsiz joyda
							saqlanadi. Bundan taşqari ma’lumotlar bazasining zaxira
							nusxalari muntazam ravişda Telegram’ga yuborib turiladi —
							server bilan nimadir bólsa ham ma’lumotni tiklaş mumkin.
							<br />
							<br />
							Bu tajriba menga dasturlaşda eng muhim narsa çiroyli kod
							emas, balki işonçlilik ekanini kórsatdi: tizim har kuni,
							har qanday şaroitda işlaşi kerak. Navbat tizimi hozir ham
							rivojlanmoqda va har bir yangi versiya real
							foydalanuvçilarning fikr-mulohazalari asosida yaxşilanmoqda.
						</div>
					</div>
				</React.Fragment>
			),
		},
	],

	notFound: {
		title: "Voy!",
		message:
			"Qidirayotgan sahifangiz topilmadi.\nSóralgan manzil \"{{url}}\" serverda mavjud emas.",
		link: "Boş sahifaga qaytiş",
	},

	skillsPage: {
		title: "Işimda foydalanadigan texnologiyalar.",
		subtitle: "Veb-ilovalarni boşidan oxirigaça — interfeysdan serverga qadar — shu texnologiyalar bilan yarataman. Navbat tizimi kabi real loyihalarda har kuni işlataman.",
		items: {
			html: "Semantik va qulay sahifa tuzilmasi, SEO uçun toza belgilaş.",
			css: "Responsiv dizayn, Flexbox va Grid, animatsiyalar va zamonaviy uslublar.",
			js: "Brauzer va server uçun asosiy til: ES6+, asinxron kod, DOM bilan işlaş.",
			react: "Komponentlar, hooklar va routing bilan tez işlaydigan interfeyslar.",
			node: "Serverlar, real vaqt xizmatlari, fon vazifalari va desktop ilovalar (Electron).",
			express: "REST API, middleware, autentifikatsiya va fayl yuklaş.",
			python: "Avtomatlaştiriş skriptlari, Telegram botlar va ma'lumotlarni qayta işlaş.",
			cpp: "Asoslardan OOPgaça: sinflar, merosxórlik, inkapsulyatsiya va polimorfizm.",
		},
	},

	seo: {
		home: {
			description:
				"Backend va veb-dasturlaş bóyiça tajribali dasturçi. React va zamonaviy texnologiyalar bilan işonçli ilovalar yaratiş.",
			keywords: ["Qodirkhan", "Nodirkhanov", "portfolio", "dasturçi"],
		},
		about: {
			description:
				"Qodirxon Nodirxonov haqida: veb-dasturlaş, React, Node.js va zamonaviy veb-ilovalar.",
			keywords: ["Qodirkhan", "portfolio", "haqida"],
		},
		articles: {
			description:
				"Maqolalar: dasturlaş, óqiş va hayotdagi yangiliklar.",
			keywords: ["Qodirkhan", "maqolalar", "blog"],
		},
		projects: {
			description:
				"Loyiha portfeli: oçiq manba va veb-işlar.",
			keywords: ["Qodirkhan", "loyihalar"],
		},
		skills: {
			description:
				"Qodirxon Nodirxonov işlatadigan texnologiyalar: HTML, CSS, JavaScript, React, Node.js, Express.js, Python, C++.",
			keywords: ["Qodirkhan", "skillar", "React", "Node.js", "Python"],
		},
		contact: {
			description:
				"Loyiha yoki hamkorlik bóyiça boǵlaniş.",
			keywords: ["Qodirkhan", "aloqa", "email"],
		},
	},
};

export default uz;
